/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGreeting",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
        ],
        name: "setName",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class HelloUpgradeableV2__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
HelloUpgradeableV2__factory.bytecode = _bytecode;
HelloUpgradeableV2__factory.abi = _abi;
//# sourceMappingURL=HelloUpgradeableV2__factory.js.map